import React from 'react'

export const Circle = ({ color = 'sienna', size = [1.3, 20], position, rotation }) => {
	return (
		<mesh position={position} rotation={rotation}>
			<circleGeometry args={size} />
			<meshStandardMaterial color={color} />
		</mesh>
	)
}
